import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Table } from 'react-bootstrap'

import { convertUTCtoMSK, truncateByWords } from '../../../../utils'
import { CashBoxAttempts, CashBoxAttemptsToggle } from '../../ticket-card/components/CashBoxAttempts'
import { ITransaction } from '../payoutTickets.types'

const COLUMNS = 6

const AttemptRow = ({ transaction }: { transaction: ITransaction }) => {
  const intl = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const expandable = Boolean(transaction.cashBoxAttempts && transaction.cashBoxAttempts.length > 0)

  return (
    <>
      <tr>
        <td style={{ width: 40 }}>
          {expandable && (
            <CashBoxAttemptsToggle isOpen={isOpen} onToggle={() => setIsOpen((prev) => !prev)} />
          )}
        </td>
        <td>{transaction.paymentAdapter || '-'}</td>
        <td>{convertUTCtoMSK(transaction.createdAt)}</td>
        <td>{transaction.completedAt ? convertUTCtoMSK(transaction.completedAt) : '-'}</td>
        <td>{intl.formatMessage({ id: `transaction.status.${transaction.status}` })}</td>
        <td>{transaction.error ? truncateByWords(transaction.error, 90) : '-'}</td>
      </tr>
      {expandable && isOpen && (
        <tr>
          <td colSpan={COLUMNS}>
            <CashBoxAttempts attempts={transaction.cashBoxAttempts} />
          </td>
        </tr>
      )}
    </>
  )
}

/** Adapter attempts of a payout; the local adapter's row expands into its cassa attempts. */
export const PayoutAttemptsBlock = ({ transactions }: { transactions?: ITransaction[] }) => {
  if (!transactions || transactions.length === 0) return null

  const sorted = transactions
    .slice()
    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())

  return (
    <div className='card mb-5'>
      <div className='card-header'>
        <div className='card-title'>Попытки</div>
      </div>
      <div className='card-body'>
        <Table bordered striped={false}>
          <thead>
            <tr className='fw-bold text-gray-700'>
              <th />
              <th>Адаптер</th>
              <th>Дата создания</th>
              <th>Дата закрытия</th>
              <th>Статус</th>
              <th>Причина отмены</th>
            </tr>
          </thead>
          <tbody>
            {sorted.map((transaction) => (
              <AttemptRow key={transaction.id ?? transaction.paymentId} transaction={transaction} />
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
